
      // https://stackoverflow.com/a/74433390
      import { Buffer } from 'buffer/';
      window.Buffer = Buffer;
      // https://stackoverflow.com/a/73208485
      window.global ||= window;
      if (global === undefined) {
        const global = window;
      }
    